import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgKebabIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <circle cx={32} cy={12} r={8} />
      <circle cx={32} cy={32} r={8} />
      <circle cx={32} cy={52} r={8} />
    </g>
  </svg>
)
export default SvgKebabIcon
